export const headCellsMap = {
    1: [
        { id: "id", numeric: false, disablePadding: true, label: "S.no" },
        { id: "packageName", numeric: false, disablePadding: true, label: "Package Name" },
        { id: "price", numeric: true, disablePadding: false, label: "Price(₹)" },
        { id: "discount", numeric: true, disablePadding: false, label: "Discount" },
        { id: "validityPeriod", numeric: true, disablePadding: false, label: "Validity Period" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "action", numeric: true, disablePadding: false, label: "Action" },
    ],

    2: [
        { id: "id", numeric: false, disablePadding: true, label: "S.no" },
        { id: "patientName", numeric: false, disablePadding: true, label: "Patient Name" },
        { id: "caseId", numeric: true, disablePadding: false, label: "Case ID" },
        { id: "carePackage", numeric: false, disablePadding: false, label: "Care Package" },
        { id: "contactNumber", numeric: false, disablePadding: false, label: "Contact Number" },
        { id: "city", numeric: false, disablePadding: false, label: "City" },
        { id: "status", numeric: true, disablePadding: false, label: "Status" },
        { id: "action", numeric: true, disablePadding: false, label: "Action" },
    ],
};
